import styled from 'styled-components';
import { FlexBoxRow } from '../FlexBoxRow';
import LiQIcon from 'src/assets/liq-brand-icon.svg';
import {useTranslation} from 'react-i18next';
import {Box, Typography, useMediaQuery} from '@mui/material';
import AiSparkle from 'src/assets/adgenerator/aisparkle.svg';
import {LyraTheme as theme} from '../../theme/lyra/Theme';
import {FontWeight} from '../../theme/lyra/FontWeight';

const FlexRow = styled(FlexBoxRow)(({ theme }) => ({
  flex: 1,
  justifyContent: 'space-between',
  background: theme.palette.common.white,
  border: `${theme.spacing(0.125)} solid ${theme.palette.grey[50]}`,
  borderRadius: theme.spacing(2.5),
  padding: `${theme.spacing(2)} ${theme.spacing(3)}`,
}));

const StyledTypography = styled(Typography)(({ theme }) => ({
  fontWeight: FontWeight.Regular,
  color: theme.palette.grey[500],
}));

const Link = styled('a')(({ theme }) => ({ cursor: 'pointer', height: theme.spacing(3.75) }));

export const NavBar = (): JSX.Element => {
  const { t } = useTranslation(['adGenerator']);
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  return (
    <FlexRow>
      <Link href="https://www.localiq.com/" target="_blank" tabIndex={-1} aria-label="LOCALiQ">
        <img src={LiQIcon} id="logo" alt="LOCALiQ" height={30} />
      </Link>
      { !isMobile &&
      <Box>
        <FlexBoxRow gap={2}>
          <img src={AiSparkle} id="AI" alt="AISparkle" height={36} />
          <StyledTypography variant='h4'>{t('toolTitle')}</StyledTypography>
        </FlexBoxRow>
      </Box>
      }
    </FlexRow>
  );
};
